import { render, staticRenderFns } from "./OrganizationStoryModal.vue?vue&type=template&id=47494a68&scoped=true&"
import script from "./OrganizationStoryModal.vue?vue&type=script&lang=js&"
export * from "./OrganizationStoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47494a68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47494a68')) {
      api.createRecord('47494a68', component.options)
    } else {
      api.reload('47494a68', component.options)
    }
    module.hot.accept("./OrganizationStoryModal.vue?vue&type=template&id=47494a68&scoped=true&", function () {
      api.rerender('47494a68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/organization/modals/OrganizationStoryModal.vue"
export default component.exports